import React from 'react';
import Experience from '../../share/Experience/Experience';
import EventDetails from '../EventDetails/EventDetails';
import EventHeader from '../EventHeader/EventHeader';

const Events = () => {
    return (
        <div>
            <EventHeader/>
            <EventDetails/>
            <Experience/>
        </div>
    );
};

export default Events;